module.exports = __webpack_public_path__ + "img/notes.b38b1e6d.svg";